import React from "react";
import Users from "./users"; // Handles user listing, editing, and creation

const UserManagement = () => {
  return (
    <>
      <div className="p-4 sm:p-6">
        <div className="mx-auto flex max-w-[1500px] flex-col gap-5">
          <div>
            <h1 className="text-2xl font-semibold">Current users</h1>
            <p className="text-sm text-muted-foreground">
              Manage portal access, contact details, and user ownership.
            </p>
          </div>
          <Users />
        </div>
      </div>
    </>
  );
};

export default UserManagement;
